module.exports = __webpack_public_path__ + "img/rouge-1.77347d32.png";